import React from 'react';
import {Link} from 'react-router';
import SortTable from '../../SortTable';
import {stringISOtoUS} from "../../../date-converter";
import {percent, convertDateTimeFormatToDate, formatNames} from "../../../utils";
import dollars from '../../../dollar-format';
import Icon from '../../Icon';
import trash from '../../../svgs/Trash.svg';

function renderInvestorContactLink(contactId, nameParts, prefix, el, propertyPath) {
    const name = nameParts(el, prefix);
    if (!name || name === '-') {
        return '-';
    }
    if (!contactId) {
        return name;
    }
    const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
    return (
        <Link
            className="green"
            to={{
                pathname: `${basePath}/investor/${contactId}`,
                state: {fromListUrl: propertyPath},
            }}
        >
            {name}
        </Link>
    );
}

const columns = (viewMode, handleDeleteHistory, propertyPath) => [{
    name: 'Period',
    code: 'ownership_period',
    render: (el) => (el.ownership_period ? el.ownership_period : (el.is_current_ownership ? 'Current' : 'Past')),
}, {
    name: 'Date',
    code: 'date',
    render: (el) => (el.date ? convertDateTimeFormatToDate(el.date) : '-'),
}, {
    name: 'Status',
    code: 'status',
    render: (el) => (el.status ? el.status : '-'),
}, {
    name: 'Agent',
    code: 'listing_agent_1_first_name',
    render: (el) => (el.listing_agent_1_first_name ? formatNames(el, 'listing_agent_1_') : formatNames(el, 'listing_agent_4_')),
}, {
    name: 'Company',
    code: 'listing_agent_firm_name',
    render: (el) => (el.listing_agent_firm_name ? el.listing_agent_firm_name : '-'),
}, {
    name: 'Price',
    code: 'price',
    render: (el) => (el.price ? dollars(el.price) : '-'),
}, {
    name: 'Cap Rate',
    code: 'cap_rate',
    render: (el) => (el.cap_rate ? percent(el.cap_rate, 2) : '-'),
}, {
    name: 'NOI',
    code: 'net_operating_income',
    render: (el) => (el.net_operating_income ? dollars(el.net_operating_income) : '-'),
}, {
    name: 'PSF',
    code: 'price_per_sqft',
    render: (el) => (el.price_per_sqft ? dollars(el.price_per_sqft, true) : '-'),
}, {
    name: 'Base Rent',
    code: 'base_rent',
    render: (el) => (el.base_rent ? dollars(el.base_rent) : '-'),
}, {
    name: 'Rent/Sq Ft',
    code: 'rent_per_sqft',
    render: (el) => (el.rent_per_sqft ? dollars(el.rent_per_sqft, true) : '-'),
}, {
    name: 'Occupancy',
    code: 'vacancy',
    render: (el) => (el.vacancy ? percent(el.vacancy, 2) : '-'),
}, {
    name: 'Buyer',
    code: 'buyer_first_name',
    render: (el) => renderInvestorContactLink(
        el.buyer_contact_id || el.buyer_id,
        formatNames,
        'buyer_',
        el,
        propertyPath
    ),
}, {
    name: 'Seller',
    code: 'seller_first_name',
    render: (el) => renderInvestorContactLink(
        el.seller_contact_id || el.seller_id,
        formatNames,
        'seller_',
        el,
        propertyPath
    ),
}, {
    name: '',
    render: (el) => (el.arcimedes_row_id && !viewMode ? <div className="icon-container" onClick={() => handleDeleteHistory(el.arcimedes_row_id)}><Icon svg={trash}/></div> : ''),
}];

const PropertyHistory = ({data, query, deleted, viewMode, handleDeleteHistory, propertyPath}) => {
    const resolvedPropertyPath = propertyPath || (typeof window !== 'undefined'
        ? window.location.pathname + window.location.search
        : '');

    return (
        <div className={`Property-history${deleted ? ' deleted' : ''}`}>
            <div className='invisible'/>
            {
                data && data.length ?
                    <SortTable
                        query={query}
                        columns={columns(viewMode, handleDeleteHistory, resolvedPropertyPath)}
                        items={data}
                        classNameModifier='property-history'
                    />
                    :
                    <div className='no-results'>No results.</div>
            }
        </div>
    );
};

export default PropertyHistory;
